module.exports = __webpack_public_path__ + "static/media/Group 16.5ebe6c9f.svg";